import { GeolocalizationProvider } from "providers/geolocalization/geolocalization";
import { DomainStorageProvider } from "providers/domain-storage/domain-storage";
import { RemoteServicesProvider } from "providers/remote-services/remote-services";
import { LoginProvider } from "providers/login/login";
import { Component, Input, ViewChild, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "app/app.service";

//declare var require: any;

@Component({
    selector: "app-login",
    templateUrl: "login.html",
    styleUrls: ['./login.scss']
})
export class LoginPage implements OnInit {
    @ViewChild("loginForm") loginForm: NgForm;
    @Input() login: string = '';
    @Input() password: string = '';

    loadingComponent: any = null;
    isLoading: boolean = false;
    error: any = null;

    constructor(
        private appService: AppService,
        private router: Router,
        private route: ActivatedRoute,
        public loginProvider: LoginProvider,
        private translate: TranslateService,
        public remoteServicesProvider: RemoteServicesProvider,
        public domainStorageProvider: DomainStorageProvider,
        public geolocalizationProvider: GeolocalizationProvider
    ) {
        this.showHideMenu(false);
    }

    ngOnInit() {
        this.geolocalizationProvider.stopWatcher();
        this.geolocalizationProvider.startWatcher();
        this.loadLogin();

        this.route.queryParams
            .subscribe(params => {
               
                if(params.sso && params.sso != "0") {
                    this.isLoading = true;
                    this.loginProvider
                        .doLoginSaml(params.sso)
                        .then(success => {
                            if(success){
                                this.startupLoadData();
                            }
                            else {
                                this.presentError(
                                    this.translate.instant("LoginPage.LoginModalTitle"),
                                    this.translate.instant("LoginPage.LoginInvalidGroupModalSubTitle"),
                                    this.translate.instant("App.DismissButton")
                                );
                            }
                            this.isLoading = false;
                        }).catch(reason => {
                            this.isLoading = false;
                        });
                }
                else if(params.sso === "0"){
                    this.presentError(
                        this.translate.instant("LoginPage.LoginModalTitle"),
                        params.msg ? params.msg : this.translate.instant("LoginPage.LoginInvalidGroupModalSubTitle"),
                        this.translate.instant("App.DismissButton")
                    );
                }
            }
    );
    }
/*
    loginClickTrack(){
        wts.push(['send', 'click', {linkId:'akitonsname',customClickParameter:{1:'200.51',5:'green'}}]
        ts.push([
            'send',
            'click', 
            {    
                linkId: 'aktionsname',
                customClickParameter: {
                    1: 'teaser',2: 'top_position'    }
            }
        ]);
    }
*/
    async loadLogin() {
        if (
            this.loginProvider.isLogged() && (await this.validateGeolocalizationApi())
        ) {
            this.isLoading = true;
            //we already have a token, try to use it
            await this.geolocalizationProvider.currentPosition.subscribe(async (value) => {
                if (value) {
                    await this.domainStorageProvider.getConfigData()
                        .then(groups => {
                            this.startupLoadData();
                        });
                }
            });

            this.isLoading = false;
        }
    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    async doLogin() {
        let passData = this.password;
        let loginData = this.login;

        this.isLoading = true;
        if (await this.validateGeolocalizationApi()) {
            let login = await this.domainStorageProvider
                .doLogin(loginData, passData)
                .catch(data => {
                    //invalid login error
                    if (data && data.status === 401) {
                        this.presentError(
                            this.translate.instant("LoginPage.LoginModalTitle"),
                            this.translate.instant("LoginPage.LoginModalSubTitle"),
                            this.translate.instant("App.DismissButton")
                        );
                    }
                    else {
                        //timeout error
                        this.presentError(
                            this.translate.instant("App.ErrorLabel"),
                            this.translate.instant("App.TimeoutError"),
                            this.translate.instant("App.DismissButton")
                        );
                    }
                    return -1;
                });
            this.clearForm();
            if (login !== -1) {
                this.startupLoadData();
            }
        }
        this.isLoading = false;
    }

    private startupLoadData() {
        let groups = this.domainStorageProvider.startupLoadData();
        if (groups && groups.length > 0) {
            this.loginProvider.saveStorage();

            //success
            this.router.navigate(["/"]);

        } else {
            this.presentError(
                this.translate.instant("LoginPage.LoginModalTitle"),
                this.translate.instant("LoginPage.LoginInvalidGroupModalSubTitle"),
                this.translate.instant("App.DismissButton")
            );
            this.loginProvider.logout();
        }
    }

    async validateGeolocalizationApi() {
        if (await this.geolocalizationProvider.isBlocked()) {
            this.presentError(
                this.translate.instant("LoginPage.LoginModalTitle"),
                this.translate.instant("LoginPage.GeolocalizationBlockedMessage"),
                this.translate.instant("App.DismissButton")
            );
            return false;
        }
        return true;
    }

    clearForm() {
        if (this.loginForm)
            this.loginForm.reset();
    }

    presentError(title, subtitle, button, action = null) {
        this.error = subtitle;
    }
}
